import React, { Component } from 'react';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import Grid from '@material-ui/core/Grid';
import { KeyboardDatePicker } from '@material-ui/pickers';
import moment from 'moment';

import additionalServicesStyles from '../additionalServicesModal/additionalServicesModal.module.css';
import commonStyles from '../../../common/common.module.css';
import Awb from '../../../../models/Awb';
import addServicesRemote from '../../../../api/addServicesRemote';
import paymentsRemote from '../../../../api/paymentsRemote';
import AlternativePaymentOptions from '../../../../models/PaymentOptions';
import ApiResponse from '../../../../models/ApiResponse';
import FeeTotal from '../../../../models/FeeTotal';
import { formatCurrency } from '../../../../utils/currencyFormatter';
import { FormControl, InputLabel } from '@material-ui/core';

const styles = (theme: Theme) =>
  createStyles({
    dialog: {
      padding: '24px 24px 8px'
    },
    close: {
      position: 'absolute',
      right: '8px',
      top: '8px'
    },
    awbno: {
      fontSize: '14px',
      color: 'var(--primaryblue)',
      fontWeight: 600,
      marginTop: '4px'
    },
    dialogActions: {
      marginBottom: '16px',
      marginInline: '16px',
    },
    labelProp: {
      '& + .MuiInput-formControl': {
        marginTop: '0px',
      }
    },
  });

interface Props {
  classes: any;
  awb: Awb;
  modalOpen: boolean;
  handleClose: () => void;
  handleAddAndPay: (transactionDate: string, paymentMethod: string, paymentOther: string) => void;
}

interface State {
  transactionDate: string;
  error: boolean;
  feeTotal: number;
  paymentOptions: AlternativePaymentOptions | null;
  paymentInfoSelect: string;
  paymentOther: string;
}

class CertifiedManifestChargeModal extends Component<Props, State> {
  state: State = {
    transactionDate: moment().format('YYYYMMDD'),
    error: false,
    feeTotal: 0,
    paymentOptions: null,
    paymentInfoSelect: '',
    paymentOther: ''
  };

  componentDidMount() {
    this.fetchFee();
    paymentsRemote.getPaymentOptions().then((resp: ApiResponse<AlternativePaymentOptions>) => {
      if (resp.result) {
        this.setState({ paymentOptions: resp.result });
      }
    });
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (prevState.transactionDate !== this.state.transactionDate) {
      this.fetchFee();
    }
  }

  fetchFee = () => {
    const { awb } = this.props;
    if (awb && this.state.transactionDate) {
      addServicesRemote.getFee('certified_manifest_charge', awb.code, awb.number, awb.version, { transaction_date: this.state.transactionDate }, true).then((res: ApiResponse<FeeTotal>) => {
        if (res.result && res.result.total !== undefined) {
          this.setState({ feeTotal: res.result.total });
        }
      });
    }
  }

  handleConfirm = () => {
    if (!this.state.transactionDate || !this.state.paymentInfoSelect || (this.state.paymentInfoSelect === 'other' && !this.state.paymentOther)) {
      this.setState({ error: true });
      return;
    }
    this.props.handleAddAndPay(this.state.transactionDate, this.state.paymentInfoSelect, this.state.paymentOther);
  }

  render() {
    const { classes, awb, modalOpen, handleClose } = this.props;

    if (!awb) return null;

    let payOptions: any = [];
    if (this.state.paymentOptions && this.state.paymentOptions.options) {
      payOptions = this.state.paymentOptions.options.options.map((item: any, index: number) => {
        return (
          <option key={index} value={item.value}>{item.name}</option> 
        );
      });
    }

    return (
      <Dialog
        open={modalOpen}
        aria-labelledby="form-dialog-title"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle className={classes.dialog}>
          <div className={additionalServicesStyles.titleWrapper}>
            <h1 className={additionalServicesStyles.titleWrapperTitle}>Add Certified Manifest Charge</h1>
            <IconButton aria-label="Close" className={classes.close} onClick={handleClose}>
              <CloseIcon color='primary' />
            </IconButton>
          </div>
          <div className={additionalServicesStyles.titleModal}>
            <span className={`${additionalServicesStyles.titleModalAwbno} ${classes.awbno}`}>for AWB: {awb.code}-{awb.number}</span>
          </div>
          <hr />
        </DialogTitle>
        <DialogContent>
          <div className={`${commonStyles.wrapper} ${commonStyles.mb0}`}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
              <KeyboardDatePicker
                fullWidth
                disableToolbar
                variant="inline"
                inputVariant="standard"
                format="MM/DD/YYYY"
                margin="none"
                id="date-picker-manifest"
                label="Transaction Date"
                value={moment(this.state.transactionDate, 'YYYYMMDD')}
                onChange={(date) => this.setState({ transactionDate: date ? date.format('YYYYMMDD') : moment().format('YYYYMMDD'), error: false })}
                className={`${commonStyles.customTextField}`}
                InputProps={{
                  disableUnderline: true,
                }}
                InputLabelProps={{
                  shrink: true,
                  className: `${commonStyles.customLabelProp} ${classes.labelProp}`,
                }}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
              />
              {this.state.error && <p style={{ color: 'red' }}>Please select a valid date</p>}
              </Grid>
              <Grid item xs={12} sm={6}>
              <TextField
                disabled
                label="Total Cost"
                value={ formatCurrency(this.state.feeTotal, 2, '$') }
                variant="standard"
                fullWidth
                className={ `${commonStyles.customTextField}` }
                InputProps={{
                  disableUnderline: true,
                }}
                InputLabelProps={{
                  shrink: true,
                  className: `${commonStyles.customLabelProp} ${classes.labelProp}`
                }}
              />
              </Grid>
              <Grid item xs={12} sm={12}>
                <FormControl variant="standard" fullWidth className={commonStyles.customTextField}>
                  <InputLabel shrink className={`${commonStyles.customLabelProp} ${classes.labelProp}`}>Paid Via</InputLabel>
                  <Select
                    native
                    value={this.state.paymentInfoSelect}
                    onChange={(event: any) => this.setState({ paymentInfoSelect: event.target.value, error: false })}
                    inputProps={{
                      name: 'paymentInfo',
                      id: 'paymentInfo',
                      classes: { notchedOutline: commonStyles.noNotch},
                      disableUnderline: true,
                    }}
                    variant="standard"
                    fullWidth
                    className={commonStyles.customTextField}
                  >
                    <option value="" />
                    {payOptions}
                  </Select>
                  {this.state.error && (!this.state.paymentInfoSelect || (this.state.paymentInfoSelect === 'other' && !this.state.paymentOther)) && 
                    <p style={{ color: 'red', marginTop: '5px', fontSize: '14px' }}>Please select a valid payment method</p>
                  }
              </FormControl>
              </Grid>
              {this.state.paymentInfoSelect === 'other' && (
                <Grid item xs={12} sm={12}>
                  <TextField
                    label="Specify payment method"
                    id="outlined-helperText"
                    value={this.state.paymentOther}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => this.setState({ paymentOther: event.target.value, error: false })}
                    variant="standard"
                    fullWidth
                    className={ commonStyles.customTextField }
                    InputProps={{
                      disableUnderline: true,
                    }}
                    InputLabelProps={{
                      shrink: true,
                      className: `${commonStyles.customLabelProp} ${classes.labelProp}`,
                    }}
                  />
                </Grid>
              )}
            </Grid>
          </div>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
            <Button onClick={handleClose}>Cancel</Button>
            <Button color="primary" variant="contained" onClick={this.handleConfirm}>Confirm & Pay</Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(styles)(CertifiedManifestChargeModal);